import { useReactiveVar } from '@apollo/client';
import { TeliaIcon, TeliaImage, TeliaStyleLink } from '@teliads/components/react';
import { useTranslation } from 'react-i18next';

import { urlLanguage } from 'apollo';
import Heading from 'components/voca/heading/Heading';
import { ArticleBodyBlockPersonFragment } from 'graphql/__generated/sdk';
import { TFunction } from 'i18n';
import { generateEntrySlug } from 'utils/mappers';
import { createMultipleSizeImages, getLinkTarget } from 'utils/utils';
import './BoardMemberCard.scss';

interface Props {
  data: ArticleBodyBlockPersonFragment;
}

export default function BoardMemberCard({ data }: Props) {
  const { t }: { t: TFunction } = useTranslation();
  const currentUrlLanguage = useReactiveVar(urlLanguage);

  const { fullName, position } = data;

  const linkTo = generateEntrySlug(data, currentUrlLanguage);

  const [image] = data.images.items;
  const imageSizes = createMultipleSizeImages({
    url: image.image.url,
    altText: image.altText,
    focusArea: image.focusArea,
  });

  return (
    <div className="board-member-card">
      <TeliaImage
        dataTestid="board-member-image"
        variant="scalable"
        src={imageSizes.small}
        alt={t('board_member_portrait')}
        className="board-member-card__image"
      />

      <div className="board-member-card__content">
        <section className="member-information">
          <Heading tag="h3" variant="title-100" className="member-information__full-name">
            {fullName}
          </Heading>

          <div className="member-information__occupation">{position}</div>
        </section>

        <TeliaStyleLink variant="navigation" className="board-member-card__link">
          <a
            href={linkTo}
            target={getLinkTarget(linkTo)}
            aria-label={`${t('read_more_about_board_member', { boardMember: fullName })}`}
          >
            <span>{t('read_more')}</span>

            <TeliaIcon name="arrow-right" size="sm" />
          </a>
        </TeliaStyleLink>
      </div>
    </div>
  );
}
